import { ReleaseHighlightDto, UpsertReleaseHighlightDto } from "@/shared/types";

export type ReleaseHighlight = {
    id: number;
    datum: Date;
    titel: string;
    korteOmschrijving: string;
    volledigeOmschrijving: string;
};

const MAX_VISIBLE_MESSAGES = 5;

export const ReleaseHighlight = {
    maxVisibleMessages: MAX_VISIBLE_MESSAGES,

    fromDto: (dto: ReleaseHighlightDto): ReleaseHighlight => ({
        id: dto.id,
        datum: new Date(dto.publicatieDatum),
        titel: dto.titel,
        korteOmschrijving: dto.omschrijving,
        volledigeOmschrijving: dto.tekst,
    }),

    fromDtos: (dtos: ReleaseHighlightDto[]): ReleaseHighlight[] =>
        dtos.map(ReleaseHighlight.fromDto).sort((a, b) => b.datum.getTime() - a.datum.getTime()),

    toUpsertDto: (bericht: Omit<ReleaseHighlight, "id">): UpsertReleaseHighlightDto => ({
        titel: bericht.titel,
        omschrijving: bericht.korteOmschrijving,
        tekst: bericht.volledigeOmschrijving,
        publicatieDatum: bericht.datum.toISOString(),
    }),

    isPublished: (bericht: ReleaseHighlight, now: Date = new Date()): boolean => {
        const publicationTime = bericht.datum.getTime();
        const nowTime = now.getTime();
        return publicationTime <= nowTime;
    },

    getVisiblePublishedMessages: (
        berichten: ReleaseHighlight[],
        now: Date = new Date(),
        aantal = MAX_VISIBLE_MESSAGES
    ): ReleaseHighlight[] =>
        ReleaseHighlight.getAllVisibleMessages(
            berichten.filter((bericht) => ReleaseHighlight.isPublished(bericht, now)),
            aantal
        ),

    getAllVisibleMessages: (berichten: ReleaseHighlight[], aantal = MAX_VISIBLE_MESSAGES): ReleaseHighlight[] =>
        berichten.slice(0, aantal),

    isRead: (bericht: ReleaseHighlight, gelezenBerichtIds: string[]): boolean => gelezenBerichtIds.includes(String(bericht.id)),

    hasUnreadMessages: (berichten: ReleaseHighlight[], gelezenBerichtIds: string[]): boolean =>
        berichten.some((bericht) => !ReleaseHighlight.isRead(bericht, gelezenBerichtIds)),

    keepVisibleMessages: (gelezenBerichtIds: string[], visibleBerichten: ReleaseHighlight[]): string[] =>
        gelezenBerichtIds.filter((id) => visibleBerichten.some((bericht) => String(bericht.id) === id)),
};
